module.exports = __webpack_public_path__ + "img/prev-item-alt.dfd2bd36.png";